export * from './detail1095.component';



// WEBPACK FOOTER //
// ./src/app/detail1095/index.ts